module.exports = __webpack_public_path__ + "img/icon-heating.e4c95b54.svg";